import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Draggable from 'react-draggable'

class DraggablePanel extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      position: this.props.defaultPosition
    }
  }

  onStopDrag = e => this.setState({ position: {x: e.clientX, y:e.clientY } })
  hide = () => this.props.onHide()

  render() {
    return (
      <Draggable axis='both' handle='.panel-title' defaultPosition={this.state.position} onStop={this.onStopDrag}>
        <div className={ cx('panel', {hidden: !this.props.show}) }>
          <div className='panel-heading'>
            <span className='panel-title'>{this.props.title}</span>
          </div>
          { this.props.children }
        </div>
      </Draggable>
    )
  }
}

DraggablePanel.defaultProps = {
  defaultPosition: {x:100, y:100},
  onHide: () => {},
  show: false,
}

DraggablePanel.propTypes = {
  defaultPosition: PropTypes.object,
  title: PropTypes.string,
  onHide: PropTypes.func,
  show: PropTypes.bool
}

export default DraggablePanel



// WEBPACK FOOTER //
// ./src/components/widgets/DraggablePanel.js